import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { isEmptyVar } from '../../utils/VariableUtil';

const PrizesConfig = (props) => {
  const [configSaved, setConfigSaved] = useState(false);
  const [defaultPrize, setDefaultPrize] = useState({ id: 'DEFAULT_PRIZE', number: 0, isDefault: true, usageCounter: 0 });
  const [prizeSummary, setPrizeSummary] = useState({ lastPrize: '', lastWinner: '', nextPrize: '' });
  const { firestore, prizesConfig } = props;

  useEffect(() => {
    M.AutoInit();
  }, []);

  useEffect(() => {
    if (!prizesConfig) return;
    setDefaultPrize(dp => ({ ...dp, ...prizesConfig.DEFAULT_PRIZE }));
    setPrizeSummary(ps => ({ ...ps, ...prizesConfig.PRIZE_SUMMARY }));
  }, [prizesConfig]);

  const validPrizesConfig = () => !isEmptyVar(prizeSummary.nextPrize) && !isEmptyVar(defaultPrize.type) && !isEmptyVar(defaultPrize.value);

  const savePrizesConfig = (e) => {
    e.preventDefault();
    if (!validPrizesConfig()) {
      M.toast({ html: 'Fill in all the fields' });
      return;
    }
    Promise.all([savePrizesConfigById('PRIZE_SUMMARY', { ...prizeSummary, updatedAt: firestore.FieldValue.serverTimestamp() }), savePrizesConfigById('DEFAULT_PRIZE', { ...defaultPrize, updatedAt: firestore.FieldValue.serverTimestamp() })])
      .then(() => setConfigSaved(true))
      .catch((e) => M.toast({ html: `Error: ${e.message ? e.message : e}` }));
  };

  const savePrizesConfigById = (id, prizeConfig) => firestore.collection('prizesConfig').doc(id).set(prizeConfig);

  const renderPrizeSummary = () => (
    <div>
      <h5>Prize Summary</h5>
      {textInput('Last Prize ID', prizeSummary.lastPrize, 12, true)}
      {textInput('Last Winner ID', prizeSummary.lastWinner, 12, true)}
      {textInput('Next Prize ID', prizeSummary.nextPrize, 12, false, (e) => setPrizeSummary({ ...prizeSummary, nextPrize: e.target.value }))}
    </div>
  );

  const renderDefaultPrize = () => (
    <div>
      <h5>Default Prize</h5>
      {textInput('Type', defaultPrize.type, 12, false, (e) => setDefaultPrize({ ...defaultPrize, type: e.target.value }))}
      <div className={`input-field col s12`}>
        <input id={`value${defaultPrize.value}`} type="number" value={defaultPrize.value || 0} onChange={(e) => setDefaultPrize({ ...defaultPrize, value: Number(e.target.value) })} />
        <label htmlFor={`value${defaultPrize.value}`} className="active">
          Value
        </label>
      </div>
    </div>
  );

  const textInput = (label, value, colSize, disabled, setData = () => {}, onClick = () => {}) => (
    <div className={`input-field col s${colSize}`}>
      <input id={`${label}${value}`} type="text" className="validate" value={value || ''} onChange={(e) => setData(e)} disabled={disabled} onClick={() => onClick()} />
      <label htmlFor={`${label}${value}`} className="active">
        {label}
      </label>
    </div>
  );

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (configSaved) return <Redirect to="/prizesMenu" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <div className="col s12">
                <h4>Prizes Config</h4>
              </div>
            </div>
            {prizeSummary && renderPrizeSummary()}
            {defaultPrize && renderDefaultPrize()}
          </div>
          <div className="card-action">
            <button className="waves-effect waves-light btn-small" onClick={(e) => savePrizesConfig(e)}>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    prizesConfig: state.firestore.data.prizesConfig,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'prizesConfig' }]), connect(mapStateToProps))(PrizesConfig);
